import { IListing } from '@travelnest/typewriter';
import { combineReducers } from 'redux';
import { IProperty } from '../../../../../data/entities/property';

import { ICustomer } from '../../../../../data/entities/customer';
import { IContracts } from '../../../../../entities/contracts/types';
import { Actions, ActionTypes } from './actions';

export const loading = (state = false, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.ADMIN_CUSTOMER_LISTINGS_DATA_REQUEST:
			return true;
		case ActionTypes.ADMIN_CUSTOMER_LISTINGS_DATA_RECEIVE:
		case ActionTypes.ADMIN_CUSTOMER_LISTINGS_DATA_FAILURE:
			return false;
		default:
			return state;
	}
};

export const listings = (state = {} as { [id: string]: IListing[] }, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.ADMIN_CUSTOMER_LISTINGS_DATA_RECEIVE:
			return action.payload.listings;
		default:
			return state;
	}
};

export const customer = (state = {} as ICustomer, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.ADMIN_CUSTOMER_LISTINGS_DATA_RECEIVE:
			return action.payload.customer;
		default:
			return state;
	}
};

export const properties = (state = [] as IProperty[], action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.ADMIN_CUSTOMER_LISTINGS_DATA_RECEIVE:
			return action.payload.properties;
		default:
			return state;
	}
};

export const contracts = (state = {} as IContracts, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.ADMIN_CUSTOMER_LISTINGS_DATA_RECEIVE:
			return action.payload.contracts;
		default:
			return state;
	}
};

export interface IAdminCustomerEditPageState {
	loading: ReturnType<typeof loading>;
	listings: ReturnType<typeof listings>;
	customer: ReturnType<typeof customer>;
	properties: ReturnType<typeof properties>;
	contracts: ReturnType<typeof contracts>;
}

export default combineReducers<IAdminCustomerEditPageState>({
	loading,
	listings,
	customer,
	properties,
	contracts
});
